import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="google-authenticator"
export default class extends Controller {
  static targets = ["code"]

  connect() {
    if (this.hasCodeTarget) {
      this.codeTarget.focus()
    }
  }

  checkCode(event) {
    const value = event.target.value
    
    event.target.value = value.replace(/\D/g, '')
    
    if (event.target.value.length === 6) {
      setTimeout(() => {
        event.target.form.submit()
      }, 100)
    }
  }

  copySecret(event) {
    const secretInput = document.querySelector('input[readonly]')
    if (secretInput) {
      secretInput.select()
      secretInput.setSelectionRange(0, 99999)
      
      try {
        document.execCommand('copy')
        const button = event.target
        const originalText = button.textContent
        button.textContent = '✓ Copié!'
        button.classList.add('is-success')
        
        setTimeout(() => {
          button.textContent = originalText
          button.classList.remove('is-success')
        }, 2000)
      } catch (err) {
        console.error('Erreur lors de la copie:', err)
      }
    }
  }
}
